import { Query } from 'react-apollo'
import React, { Component } from 'react'

import { Container, ErrorComponent, LoadingComponent } from 'components'
import Header from './Header'
import SidebarNav from './SidebarNav'
import MainContent from './MainContent'

import query from './TrailDetails.query.js'

import styles from './TrailDetails.module.css'

class TrailDetails extends Component {
  state = {
    navigateTo: null,
  }

  componentDidUpdate() {
    window.scrollTo(0, 0)
  }

  activateNode = (nid, redirect) => {
    if (redirect) {
      this.props.history.replace(`#${nid}`)
    }

    return { nid: nid, pos: 0 }
  }

  sortNodes = nodes => {
    return nodes.sort((a, b) => {
      return a.weight - b.weight
    })
  }

  entityTrailNodes = entity => {
    if (entity && entity.trailArticles && entity.trailArticles.nodes) {
      const nodes = entity.trailArticles.nodes.filter(Boolean)

      return nodes.length > 1 ? this.sortNodes(nodes) : nodes
    }
    return []
  }

  getItems = entity => {
    let currentItem,
      currentItemObj = {},
      prevItem,
      nextItem = null,
      presentation = !!entity.presentationEnabled ? entity.presentation : null

    const nodes = this.entityTrailNodes(entity)

    if (nodes.length > 0) {
      let firstNodeId = nodes[0].nid

      // Build currentItemObj, which will be used by prevItem and nextItem.
      if (!this.props.location.hash) {
        if (!presentation) {
          // Activate the first node.
          currentItemObj = this.activateNode(firstNodeId)
        }
      } else {
        currentItemObj = nodes
          .map((item, index) => ({
            nid: item.nid,
            pos: index,
          }))
          .find(item => item.nid === parseInt(this.props.location.hash.substr(1)))

        if (!currentItemObj) {
          // Activate the first node.
          currentItemObj = this.activateNode(firstNodeId, true)
        }
      }

      if (Object.keys(currentItemObj).length > 0) {
        // Assign plain value to currentItem.
        currentItem = currentItemObj.nid

        // Build logic for nextItem and prevItem.
        if (nodes.length > 1) {
          const nextNode = nodes[currentItemObj.pos + 1]
          const prevNode = nodes[currentItemObj.pos - 1]

          // nextItem object.
          nextItem = {
            nid: nextNode ? nextNode.nid : null,
            title: nextNode ? nextNode.title : null,
            pos: currentItemObj.pos + 2,
          }
          // prevItem object.
          prevItem = {
            nid: prevNode ? prevNode.nid : null,
            title: prevNode ? prevNode.title : null,
            pos: currentItemObj.pos,
          }

          // Remove nextItem and prevItem when not necessary.
          if (currentItemObj.pos === 0) {
            prevItem = {}
          } else if (currentItemObj.pos === nodes.length - 1) {
            nextItem = {}
          }
        }
      }
    }

    return { currentItem, prevItem, nextItem, presentation, nodes }
  }

  render() {
    return (
      <>
        <Query query={query} variables={{ path: this.props.match.url }}>
          {({ loading, error, data }) => {
            if (loading) {
              return <LoadingComponent />
            }

            if (error) {
              return <ErrorComponent message={`Error! ${error.message}`} />
            }

            if (!data.route) {
              return <ErrorComponent message='Página não encontrada' />
            }

            const entity = data.route.entity
            const { currentItem, nextItem, prevItem, presentation, nodes } = this.getItems(entity)

            if (nodes.length === 0) {
              return <ErrorComponent message='Não há conteúdo disponível para essa trilha.' />
            }

            return (
              <>
                <Header title={entity.name} />
                <Container flex>
                  <div className={styles.wrapper}>
                    <SidebarNav currentItem={currentItem} items={nodes} title={entity.name} />
                    <MainContent
                      currentItem={currentItem}
                      nextItem={nextItem}
                      prevItem={prevItem}
                      items={nodes}
                      presentation={presentation}
                    />
                  </div>
                </Container>
              </>
            )
          }}
        </Query>
      </>
    )
  }
}

export default TrailDetails
